import './lle_details.css';
import React, { useState, useEffect } from "react";
import { fileNameValidation, nameValidation, VALIDATION } from "../../../../common/commonValidations";
import { useNavigate, useLocation } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import { SALUTATION, APPLICATION_ADDRESS_EVIDENCE, EXISTING_OCC, GENDER, HIGHEST_QUALIFICATION, LLE_TRADE_LICENSE, MOA_REGISTRATION_CERTIFICATE, FILE_NAME_VALIDATION_ERROR } from '../../../../common/constants';
import { getLocalStorageItem } from '../../../../common/localStorageUtils';
import { Container, Card, CardContent, Button, ToggleButton, ToggleButtonGroup, Box, Typography, Grid, TextField } from '@mui/material';
import { PROD } from '../../../../common/constants';
import { downloadDocument, uploadDocument } from '../../../../common/Utils';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';
import { handleNumberFieldFocus } from '../../../../common/commonFunction';
import { ArrowBackIosNewIcon, ArrowForwardIosIcon } from '../../../../common/icons';

const LLEDetailsScreenTwo = () => {
    const { t, i18n } = useTranslation();
    const [verifyMobileNo, setVerifyMobileNo] = useState(false);
    const [backButtonData, setBackButtonData] = useState();
    const [selectedApplicant, setSelectedApplicant] = useState('Individual');
    const [pincodeAddressDetails, setPincodeAddressDetails] = useState();
    const [prevScreenData, setPrevScreenData] = useState();
    const [documentDetailsObj, setDocumentDetailsObj] = useState({
        id: null,
        documentType: null,
        documentName: null,
        documentBlobName: null,
        documentPath: null,
        documentContainerName: "stakeholder",
        stakeholderType: "lle",
        stakeholderDetailId: null,
        isActive: 1,
        createdOn: null,
        createdBy: null,
        updatedOn: null,
        updatedBy: null,
    });
    const [documentUploadDetails, setDocumentUploadDetails] = useState();
    const [selectedFile, setSelectedFile] = useState();
    const [documentDetailsArr, setDocumentDetailsArr] = useState([]);

    const [addressCertiFileName, setAddressCertiFileName] = useState();
    const [highestEducationFileName, setHighestEducationFileName] = useState();
    const [occupationFileName, setOccupationFileName] = useState();
    const [registrationFileName, setRegistrationFileName] = useState();
    const allowedTypes = ["image/png", "image/jpg", "image/jpeg", "application/pdf"];

    const [details, setDetails] = useState({
        fullName: '',
        mobileNo: '',
        emailId: '',
        companyType: '',
        pincode: '',
        contactPersonFirstName: '',
        contactPersonMiddleName: '',
        contactPersonLastName: '',
        contactPersonSalutation: 'Mr',
        contactPersonGender: 'Male',
        residenceProof: '',
        registrationNo: '',
        educationQualification: '',
        netWorth: '',
        workingCapital: '',
        typeOfOcc: '',
        address: '',


    });
    const navigate = useNavigate();
    const location = useLocation();
    const [errorMessage, setErrorMessage] = useState({
        fullNameError: '',
        contactPersonNameError: '',
        contactPersonMiddleNameError: '',
        contactPersonLastNameError: '',
        mobileNoError: '',
        pincodeError: '',
        searchError: '',
        emailIdError: '',
        addressError: '',
        residenceProofError: '',
        registrationNoError: '',
        educationQualificationError: '',
        netWorthError: '',
        workingCapitalError: '',
        typeOfOccError: '',
        educationOrMoaDocError: '',
        businessDocError: ''
    });
    const [documentDetails, setDocumentDetails] = useState({
        id: null,
        documentType: null,
        documentName: null,
        documentBlobName: null,
        documentPath: null,
        documentContainerName: "stakeholder",
        stakeholderType: "lle",
        stakeholderDetailId: null,
        isActive: 1
    });

    const onClickVerifyMobileNo = (e) => {
        e.preventDefault();
        setVerifyMobileNo(true);
    }
    const isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    }

    useEffect(() => {
        setBackButtonData(location.state.data)
        if (backButtonData) {
            setDetails({
                registrationNo: backButtonData.registrationNumber,
                educationQualification: backButtonData.highestEducationalQualification,
                netWorth: backButtonData.netWorth,
                workingCapital: backButtonData.workingCapital,
                typeOfOcc: backButtonData.existingOccupation,
                address: backButtonData.address,
                landArea: backButtonData.landAreaValue + " " + backButtonData.landAreaUnit


            });
            // setHighestEducationFileName(backButtonData.documents?.[0].documentName)
            setHighestEducationFileName(backButtonData?.documents?.[0]?.documentType === "HighestQualification" ? backButtonData?.documents?.[0]?.documentName : backButtonData?.documents?.[1]?.documentType === "HighestQualification" ? backButtonData?.documents?.[1]?.documentName : backButtonData?.documents?.[2]?.documentType === "HighestQualification" ? backButtonData?.documents?.[2]?.documentName : backButtonData?.documents?.[3]?.documentType === "HighestQualification" ? backButtonData?.documents?.[3]?.documentName : backButtonData?.documents?.[4]?.documentType === "HighestQualification" ? backButtonData?.documents?.[4]?.documentName : backButtonData?.documents?.[5]?.documentType === "HighestQualification" ? backButtonData?.documents?.[5]?.documentName : "")
            setRegistrationFileName(backButtonData?.documents?.[0]?.documentType === "MOA_RegistrationCertificate" ? backButtonData?.documents?.[0]?.documentName : backButtonData?.documents?.[1]?.documentType === "MOA_RegistrationCertificate" ? backButtonData?.documents?.[1]?.documentName : backButtonData?.documents?.[2]?.documentType === "MOA_RegistrationCertificate" ? backButtonData?.documents?.[2]?.documentName : backButtonData?.documents?.[3]?.documentType === "MOA_RegistrationCertificate" ? backButtonData?.documents?.[3]?.documentName : backButtonData?.documents?.[4]?.documentType === "MOA_RegistrationCertificate" ? backButtonData?.documents?.[4]?.documentName : backButtonData?.documents?.[5]?.documentType === "MOA_RegistrationCertificate" ? backButtonData?.documents?.[5]?.documentName : "")
            setOccupationFileName(backButtonData?.documents?.[0]?.documentType === "ExistingOcc" ? backButtonData?.documents?.[0]?.documentName : backButtonData?.documents?.[1]?.documentType === "ExistingOcc" ? backButtonData?.documents?.[1]?.documentName : backButtonData?.documents?.[2]?.documentType === "ExistingOcc" ? backButtonData?.documents?.[2]?.documentName : backButtonData?.documents?.[3]?.documentType === "ExistingOcc" ? backButtonData?.documents?.[3]?.documentName : backButtonData?.documents?.[4]?.documentType === "ExistingOcc" ? backButtonData?.documents?.[4]?.documentName : backButtonData?.documents?.[5]?.documentType === "ExistingOcc" ? backButtonData?.documents?.[5]?.documentName : "")
        }

    }, [backButtonData]);
    useEffect(() => {
        const data = location?.state?.data?.documents;
        setPrevScreenData(location.state.data)

        { data?.length > 0 ? setDocumentDetailsArr(location?.state?.data?.documents) : setSelectedApplicant(location.state.data?.applicantType); }
        setSelectedApplicant(location.state.data?.applicantType);

    }, [prevScreenData]);
    const deleteDocument = (blobFileName, documentType) => {
        let existingData = documentDetailsArr.filter((item) => item.documentType === documentType && item.documentBlobName === blobFileName);
        let tempArr = documentDetailsArr.filter((item) => item.documentBlobName !== blobFileName);
        if (existingData && existingData[0]) {
            if (existingData[0].id) {
                existingData[0].isActive = 0;
                tempArr?.push(existingData[0]);
            }
        }
        setDocumentDetailsArr(tempArr);
    };
    const onUploadDocument = (e, type) => {
        if (allowedTypes.indexOf(e.target.files[0].type) < 0) {
            return;
        }
        if (e.target.files[0].name.split('.').length > 2) {
            setErrorMessage({
                ...errorMessage,
                educationOrMoaDocError: "Double extension file detected",

            });
            return;
        }
        if (e.target.files[0].size >= 5000000) {
            setErrorMessage({
                ...errorMessage,
                educationOrMoaDocError: "The file should be less than 5MB",
            });

        }
        else if (fileNameValidation(e.target.files[0].name)) {
            setErrorMessage({
                ...errorMessage,
                educationOrMoaDocError: FILE_NAME_VALIDATION_ERROR,
            });

        }
        else {
            setErrorMessage({ ...errorMessage, educationOrMoaDocError: " " });
            setSelectedFile(e.target.files[0]);
            setDocumentDetailsObj({
                ...documentDetailsObj,
                documentType: type,
                stakeholderDetailId: null,
            })
        }


        if (type === APPLICATION_ADDRESS_EVIDENCE) {
            setAddressCertiFileName(e.target.files[0].name)
        } else if (type === HIGHEST_QUALIFICATION) {
            setHighestEducationFileName(e.target.files[0].name)
        } else if (type === MOA_REGISTRATION_CERTIFICATE) {
            setRegistrationFileName(e.target.files[0].name)
        } else if (type === EXISTING_OCC) {
            setOccupationFileName(e.target.files[0].name)
        }
        uploadDocument(e.target.files[0], type, callbackUpload);
    };
    const onUploadDocumentExistingBusiness = (e, type) => {
        if (allowedTypes.indexOf(e.target.files[0].type) < 0) {
            return;
        }
        if (e.target.files[0].name.split('.').length > 2) {
            setErrorMessage({
                ...errorMessage,
                businessDocError: "Double extension file detected",
            });
            return;
        }
        if (e.target.files[0].size >= 5000000) {
            setErrorMessage({
                ...errorMessage,
                businessDocError: "The file should be less than 5MB",
            });

        }
        else if (fileNameValidation(e.target.files[0].name)) {
            setErrorMessage({
                ...errorMessage,
                businessDocError: FILE_NAME_VALIDATION_ERROR,
            });

        }
        else {
            setErrorMessage({ ...errorMessage, businessDocError: " " });
            setSelectedFile(e.target.files[0]);
            setDocumentDetailsObj({
                ...documentDetailsObj,
                documentType: type,
                stakeholderDetailId: null,
            })
        }


        if (type === APPLICATION_ADDRESS_EVIDENCE) {
            setAddressCertiFileName(e.target.files[0].name)
        } else if (type === HIGHEST_QUALIFICATION) {
            setHighestEducationFileName(e.target.files[0].name)
        } else if (type === MOA_REGISTRATION_CERTIFICATE) {
            setRegistrationFileName(e.target.files[0].name)
        } else if (type === EXISTING_OCC) {
            setOccupationFileName(e.target.files[0].name)
        }
        uploadDocument(e.target.files[0], type, callbackUpload);
    };
    const callbackUpload = (response, type) => {
        setDocumentUploadDetails(response);
        var document = {
            id: null,
            documentType: type,
            documentName: response?.blobResponse?.fileName,
            documentBlobName: response?.blobResponse?.blobFileName,
            documentPath: null,
            documentContainerName: "stakeholder",
            stakeholderType: "LLE",
            //stakeholderDetailId: props.stakeholderDetailId,
            isActive: 1
        }
        var tempArr = documentDetailsArr;
        tempArr.push(document);
        setDocumentDetailsArr(tempArr);
    }
    const handleChange = (e) => {
        setDetails({ ...details, [e.target.name]: e.target.value })
        if (e.target.name === "registrationNo") {
            if ((e.target.value).length > 0) {
                setDetails({ ...details, [e.target.name]: e.target.value.toUpperCase() })
                setErrorMessage({ ...errorMessage, registrationNoError: "" })
            } else {
                setErrorMessage({ ...errorMessage, registrationNoError: "Please enter Registration/Incorporation No." })

            }
        }
        if (e.target.name === "educationQualification") {
            if ((e.target.value).length > 0) {
                setDetails({ ...details, [e.target.name]: VALIDATION.fullNameValidation(e.target.value.slice(0, 50)) })
                setErrorMessage({ ...errorMessage, educationQualificationError: "" })
            } else {
                setErrorMessage({ ...errorMessage, educationQualificationError: "Please enter Highest Educational Qualification" })

            }
        }
        if (e.target.name === "netWorth") {
            const limit = 10;
            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            if ((e.target.value).length > 0) {
                setErrorMessage({ ...errorMessage, netWorthError: "" })
            } else {
                setErrorMessage({ ...errorMessage, netWorthError: "Please enter Net Worth" })

            }
        }
        if (e.target.name === "workingCapital") {
            const limit = 10;
            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            if ((e.target.value).length > 0) {
                setErrorMessage({ ...errorMessage, workingCapitalError: "" })
            } else {
                setErrorMessage({ ...errorMessage, workingCapitalError: "Please enter Working Capital" })

            }
        }
        if (e.target.name === "typeOfOcc") {
            if ((e.target.value).length > 0) {
                setDetails({ ...details, [e.target.name]: VALIDATION.fullNameValidation(e.target.value.slice(0, 50)) })
                setErrorMessage({ ...errorMessage, typeOfOccError: "" })
            } else {
                setErrorMessage({ ...errorMessage, typeOfOccError: "Please enter Type of Business/Occupation" })

            }
        }
    };
    const onSubmit = (e) => {
        e.preventDefault();
        let educationDoc = documentDetailsArr && documentDetailsArr.filter((item) => item.documentType === HIGHEST_QUALIFICATION && item.isActive == 1);
        let moaDoc = documentDetailsArr && documentDetailsArr.filter((item) => item.documentType === MOA_REGISTRATION_CERTIFICATE && item.isActive == 1);
        let businessDoc = documentDetailsArr && documentDetailsArr.filter((item) => item.documentType === EXISTING_OCC && item.isActive == 1);
        // if (selectedApplicant === 'Individual' && !details.educationQualification) {
        //     setErrorMessage({ ...errorMessage, educationQualificationError: "Please enter Highest Educational Qualification" })
        // }
        // else if (selectedApplicant !== 'Individual' && !details.registrationNo) {
        //     setErrorMessage({ ...errorMessage, registrationNoError: "Please enter Registration No " })
        // }
        // else if (!details.typeOfOcc) {
        //     setErrorMessage({ ...errorMessage, typeOfOccError: "Please enter Type of Business/Occupation  " });
        // }
        // else if (!details.netWorth) {
        //     setErrorMessage({ ...errorMessage, netWorthError: "Please enter Net Worth " });
        // }
        // else if (!details.workingCapital) {
        //     setErrorMessage({ ...errorMessage, workingCapitalError: "Please enter Working Capital " });
        // }
        // else if (selectedApplicant === 'Individual' && educationDoc.length == 0) {
        //     setErrorMessage({ educationOrMoaDocError: "Please upload educational qualification document" });
        // }
        // else if (selectedApplicant !== 'Individual' && moaDoc.length == 0) {
        //     setErrorMessage({ educationOrMoaDocError: "Please upload MOA/Registration document" });
        // }
        // else if (businessDoc.length == 0) {
        //     setErrorMessage({ businessDocError: "Please upload existing business/occupation document" });
        // }
        // else 
        submitLLEDetails();
    }

    const onClickDocument = (e, blobFileName, documentName) => {
        e.preventDefault();
        downloadDocument(blobFileName, documentName, null);
    };
    const OnPrevious = () => {
        const dataForApi = {
            ...prevScreenData,
            "highestEducationalQualification": details.educationQualification,
            "registrationNumber": details.registrationNo,
            "netWorth": details.netWorth,
            "workingCapital": details.workingCapital,
            "existingOccupation": details.typeOfOcc,
            "documents": documentDetailsArr,

        }
        navigate('/lleSubCategory', { state: { data: dataForApi } })
    }

    const submitLLEDetails = () => {
        const dataForApi = {
            ...prevScreenData,
            "highestEducationalQualification": details.educationQualification,
            "registrationNumber": details.registrationNo,
            "netWorth": details.netWorth,
            "workingCapital": details.workingCapital,
            "existingOccupation": details.typeOfOcc,
            "documents": documentDetailsArr,

        }
        navigate(getLocalStorageItem('id_token') ? "/registrationHome/preregistration/lleoptedLocation" : '/preregistration/lleoptedLocation', { state: { data: dataForApi } });
    }

    const onApplicantClick = (e) => {
        setSelectedApplicant(e.target.value)
        e.preventDefault()
    }

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>REG05</p>}
                <Card>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            {t('preReg.applicantGeneralInfo')}
                        </Typography>
                        <Typography variant="subtitle2" gutterBottom>
                            {t('preReg.applicantType')}
                        </Typography>
                        <ToggleButtonGroup style={{ display: "flex", overflow: "auto" }}
                            color="primary"
                            value={selectedApplicant}
                            exclusive
                            onChange={(e) => onApplicantClick(e)}
                            aria-label="Platform"
                        >
                            <ToggleButton disabled value="Individual">{t('preReg.individual')}</ToggleButton>
                            <ToggleButton disabled value="SHG/Co-opetative">{t('preReg.shg')}/{t('preReg.cooperative')}</ToggleButton>
                            <ToggleButton disabled value="Firm/Enterprise">{t('preReg.firm')}/{t('preReg.enterprise')}</ToggleButton>
                        </ToggleButtonGroup>
                        <Grid container spacing={2} direction="row" mt={1}>
                            <Grid item xs={12} lg={6}>
                                <Typography variant="h6" style={{ marginBottom: "1em" }} gutterBottom>
                                    {selectedApplicant === 'Individual' ? t('preReg.qualification') : t('preReg.credentials')}
                                </Typography>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        {selectedApplicant === 'Individual' ? <><TextField fullWidth
                                            // required
                                            error={errorMessage.educationQualificationError}
                                            helperText={errorMessage.educationQualificationError}
                                            type="text"
                                            label={t('preReg.highestQualification')}
                                            name="educationQualification"
                                            value={details.educationQualification}
                                            onChange={(e) => handleChange(e)} />
                                            {documentDetailsArr?.filter(item => item.documentType === HIGHEST_QUALIFICATION && item.isActive === 1).map(item => (
                                                <div className="chooseFile_storage">
                                                    <a onClick={(e) => onClickDocument(e, item.documentBlobName, item.documentName)}>{item.documentName}</a>
                                                    <IconButton size='small' className='icon_button_grower_pre_reg' color="primary" aria-label="search"
                                                        onClick={() => deleteDocument(item.documentBlobName, item.documentType)}>
                                                        <DeleteIcon color='error' fontSize='inherit' />
                                                    </IconButton>
                                                </div>
                                            ))
                                            }
                                            {(documentDetailsArr)?.filter(item => item.documentType === HIGHEST_QUALIFICATION && item.isActive === 1).length == 0 ?
                                                <label className="chooseFile_storage">
                                                    <input type="file" accept="image/png, image/jpg, image/jpeg ,.doc, .pdf" name="uploadedfile2"
                                                        style={{ display: "none" }}
                                                        onChange={(e) => onUploadDocument(e, HIGHEST_QUALIFICATION)} />
                                                    {t('preReg.uploadFile')}
                                                </label> : null}
                                            <div className='mandatory_field'>{errorMessage.educationOrMoaDocError}</div>
                                        </>
                                            :
                                            <>
                                                <TextField fullWidth
                                                    // required
                                                    error={errorMessage.registrationNoError}
                                                    helperText={errorMessage.registrationNoError}
                                                    type="text"
                                                    label="MOA/Registration/Incorporation No"
                                                    name="registrationNo"
                                                    value={details.registrationNo || ''}
                                                    onChange={(e) => handleChange(e)} />
                                                {documentDetailsArr?.filter(item => item.documentType === MOA_REGISTRATION_CERTIFICATE && item.isActive === 1).map(item => (
                                                    <div className="chooseFile_storage">
                                                        <a onClick={(e) => onClickDocument(e, item.documentBlobName, item.documentName)}>{item.documentName}</a>
                                                        <IconButton size='small' className='icon_button_grower_pre_reg' color="primary" aria-label="search"
                                                            onClick={() => deleteDocument(item.documentBlobName, item.documentType)}>
                                                            <DeleteIcon color='error' fontSize='inherit' />
                                                        </IconButton>
                                                    </div>
                                                ))
                                                }
                                                {(documentDetailsArr)?.filter(item => item.documentType === MOA_REGISTRATION_CERTIFICATE && item.isActive === 1).length == 0 ?
                                                    <label className="chooseFile_storage">
                                                        <input type="file" accept="image/png, image/jpg, image/jpeg ,.doc, .pdf" name="uploadedfile2"
                                                            style={{ display: "none" }}
                                                            onChange={(e) => onUploadDocument(e, MOA_REGISTRATION_CERTIFICATE)} />
                                                        {t('preReg.uploadFile')}
                                                    </label> : null}
                                                <div className='mandatory_field'>{errorMessage.educationOrMoaDocError}</div>
                                            </>}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            // required
                                            type="text"
                                            error={errorMessage.typeOfOccError}
                                            helperText={errorMessage.typeOfOccError}
                                            label={t('preReg.typeOfBusinessOccupation')}
                                            name="typeOfOcc"
                                            value={details.typeOfOcc || ''}
                                            onChange={(e) => handleChange(e)} />
                                    </Grid>
                                    {documentDetailsArr?.filter(item => item.documentType === EXISTING_OCC && item.isActive === 1).map(item => (
                                        <div className="chooseFile_storage">
                                            <a onClick={(e) => onClickDocument(e, item.documentBlobName, item.documentName)}>{item.documentName}</a>
                                            <IconButton size='small' className='icon_button_grower_pre_reg' color="primary" aria-label="search"
                                                onClick={() => deleteDocument(item.documentBlobName, item.documentType)}>
                                                <DeleteIcon color='error' fontSize='inherit' />
                                            </IconButton>
                                        </div>
                                    ))
                                    }
                                    {(documentDetailsArr)?.filter(item => item.documentType === EXISTING_OCC && item.isActive === 1).length == 0 ?
                                        <label className="chooseFile_storage">
                                            <input type="file" accept="image/png, image/jpg, image/jpeg ,.doc, .pdf" name="uploadedfile2"
                                                style={{ display: "none" }}
                                                onChange={(e) => onUploadDocumentExistingBusiness(e, EXISTING_OCC)} />
                                            {t('preReg.uploadFile')}
                                        </label> : null}
                                    <div className='mandatory_field'>{errorMessage.businessDocError}</div>
                                    <Grid item xs={12} justifyContent="right" direction="column">
                                        <Typography variant="caption" align="right" style={{ fontStyle: "italic" }}>{t('preReg.uploadUdyamCertificate')}</Typography>
                                        <Typography variant="subtitle2" fontSize="1.8vh" align="right" color="green">{t('preReg.uploadFileTypeNote')}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Typography variant="h6" style={{ marginBottom: "1em" }} gutterBottom>
                                    {t('preReg.financialInformation')}
                                </Typography>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            // required
                                            error={errorMessage.netWorthError}
                                            helperText={errorMessage.netWorthError}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label={t('preReg.networth') + t('preReg.inINR')}
                                            name="netWorth"
                                            value={details.netWorth}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            // required
                                            error={errorMessage.workingCapitalError}
                                            helperText={errorMessage.workingCapitalError}
                                            label={t('preReg.workingCapital') + t('preReg.inINR')}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            name="workingCapital"
                                            value={details.workingCapital} onChange={(e) => handleChange(e)} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                    <Button sx={{ minWidth: 100 }} variant="contained" startIcon={<ArrowBackIosNewIcon />} onClick={() => (navigate(getLocalStorageItem('id_token') ? '/registrationHome/preregistration/lleSubCategory' : "/preregistration/lleSubCategory", { state: { data: prevScreenData } }))}>{t('preReg.previous')}</Button>
                    <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={(e) => onSubmit(e)} endIcon={<ArrowForwardIosIcon />}>{t('preReg.next')}</Button>
                </Box>
            </Container>
        </>

    );
}

export default LLEDetailsScreenTwo;
